export const DEFAULT_MARKET = 'global';
export const DEFAULT_INDUSTRY = 'any';
export const DEFAULT_SORT_BY = 'market-cap-large';
